import { render, staticRenderFns } from "./SelectItemIntents.vue?vue&type=template&id=5393290e&scoped=true&"
import script from "./SelectItemIntents.vue?vue&type=script&lang=js&"
export * from "./SelectItemIntents.vue?vue&type=script&lang=js&"
import style0 from "./SelectItemIntents.vue?vue&type=style&index=0&id=5393290e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5393290e",
  null
  
)

export default component.exports